import React, {forwardRef, useLayoutEffect, useState} from "react";
import {TaskListUnit} from "../../../API";
import {useFileProvider} from "../../../stores/AppStateContext";
import {BGAvatar, BGAvatarProps} from "./Avatar";
import {TaskListUnitModelType} from "../../../stores/taskLists/TaskListUnitModel";
import {stringToColor} from "../../../utils/stringToColor";


export type TaskListUnitAvatarProps = Omit<BGAvatarProps, 'branch' | 'color' | 'abbreviation' | 'alt'> & {
    taskListUnit: TaskListUnit | TaskListUnitModelType;
}

export const TaskListUnitAvatar = forwardRef<HTMLDivElement, TaskListUnitAvatarProps>((
    {
        taskListUnit,
        forceUpdate,
        size = 36,
        ...props
    }: TaskListUnitAvatarProps,
    ref
) => {
    const fileProvider = useFileProvider();
    const [presignedUrl, setPresignedUrl] = useState<string | undefined>(undefined);

    useLayoutEffect(() => {
        if (taskListUnit.avatarPath && fileProvider) {
            fileProvider.getSignedUrl(taskListUnit.avatarPath).then(avatarUrl => {
                if (avatarUrl !== undefined) {
                    setPresignedUrl(`${avatarUrl}`);
                }
            })
        } else {
            setPresignedUrl(undefined);
        }
    }, [taskListUnit.avatarPath, forceUpdate]);

    const branchName = taskListUnit.name;

    const color = stringToColor(taskListUnit.id + taskListUnit.name + taskListUnit.createdAt);
    return <BGAvatar
        {...props}
        sx={{borderRadius: 6}}
        color={`hsl(${color.hue}, ${color.saturation}%, ${color.lightness}%)`}
        abbreviation={branchName.charAt(0).toUpperCase()}
        alt={branchName}
        ref={ref}
        src={presignedUrl}
        size={size}
    />;
});
